export default __webpack_public_path__ + "static/media/raxi-kona-black.2d9a0e5a.png";